export enum LiveRouteType {
  /// <summary>
  /// This includes both returns and regular deliveries
  /// </summary>
  Delivery = 0,

  /// <summary>
  /// This is the Pickup part of pickup+return or pickup+delivery
  /// </summary>
  Pickup = 1,

  /// <summary>
  /// This is the Pickup part of pickup+return
  /// </summary>
  PickupReturn = 50,

  /// <summary>
  /// This is when the driver has to return to location after initial delivery, for :
  /// Codes 13, 16 : Delivery error
  /// Codes 29 : COD required
  /// Codes 57 : Signature required
  /// </summary>
  SpecialAfterDelivered = 2
}
